import { render } from "./BuildingStatisticsRow.vue?vue&type=template&id=75020b55&scoped=true"
import script from "./BuildingStatisticsRow.vue?vue&type=script&lang=js"
export * from "./BuildingStatisticsRow.vue?vue&type=script&lang=js"

import "./BuildingStatisticsRow.vue?vue&type=style&index=0&id=75020b55&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75020b55"]])

export default __exports__